export default "__VITE_ASSET__CJHarBLE__"